var map = {
	"./Anvil.svg": 7544,
	"./Archetype.svg": 5811,
	"./Artillery.svg": 6816,
	"./Blaze.svg": 8422,
	"./Bloom.svg": 235,
	"./Camp.svg": 9965,
	"./Controller.svg": 3954,
	"./Courier.svg": 4263,
	"./Crafting.svg": 5984,
	"./Defender.svg": 7471,
	"./Detonation.svg": 2865,
	"./Downtime.svg": 661,
	"./Earth.svg": 846,
	"./Flame.svg": 4931,
	"./Gale.svg": 6875,
	"./Grounding.svg": 5349,
	"./Inventory.svg": 1950,
	"./Land.svg": 7381,
	"./Metal.svg": 7983,
	"./Mountain.svg": 183,
	"./Shaper.svg": 5777,
	"./Skill.svg": 285,
	"./Stoneheart.svg": 1923,
	"./Storm.svg": 1821,
	"./Striker.svg": 5142,
	"./Supporter.svg": 178,
	"./Survivor.svg": 9928,
	"./Tide.svg": 1462,
	"./Travel.svg": 3446,
	"./Tremorsight.svg": 3396,
	"./Tundra.svg": 8178,
	"./Water.svg": 4091,
	"./Wind.svg": 7980,
	"./Wood.svg": 2573
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8696;